import { UserService } from './../../users/services/user.service';
import { User } from './../../users/models/user';

import { FoodSafetyServices } from './../../foodsafety/services/foodsafety.services';
import { FoodSafetyList } from './../../foodsafety/models/foodsafety-list';
import { CommonChecklistService } from '../../common/services/common-checklist.services';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { BusinessDepartmentService } from './../../business-department.services';
import {
  Activity,
  Execution,
  FollowUpActivity,
  Repetition
} from '../models/activities';
import { BaseServices } from './../../kuba.services';
import { ActivityServices } from './activities.services';

@Injectable()
export class ActivityEditResolver {
  constructor(private backend: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.get(+route.params['aid']);
  }
}

@Injectable()
export class ResponsiblePersonListResolver {
  constructor(private backend: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getAllFollowUp(BaseServices.BusinessId);
  }
}
@Injectable()
export class RepetionListResolver {
  constructor(private backend: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getAllRepetition();
  }
}

@Injectable()
export class DepartmentCachedListResolver {
  constructor(private backend: BusinessDepartmentService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getCachedBusinessDepartment();
  }
}
@Injectable()
export class ChecklistResolver {
  constructor(private backend: CommonChecklistService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getCheckListforTemplate(
      0,
      BaseServices.ApplicationId,
      0,
      BaseServices.BusinessId,
      0
    );
  }
}
@Injectable()
export class AdminActivityResolver {
  constructor(private backend: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getAdminActivity(BaseServices.ApplicationId);
  }
}
@Injectable()
export class ActiveBusinessResolver {
  constructor(private backend: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      let result: any = this.backend.activeBusinesslist();
      return result;
    }
  }
}
@Injectable()
export class PortalActivityResolver {
  constructor(private backend: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getPortalActivity(BaseServices.UserId);
  }
}

function getActivityFromAPI(activityId: number, activityService: ActivityServices): Observable<any> {
  console.log('Fetching activity data from API for ID:', activityId);
  return activityService.get(activityId);
}

@Injectable()
export class PortalActivityEditResolver {
  constructor(private backend: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    const activityId = +route.params['aid'];
    const routerState = window.history.state;
    
    if (routerState && routerState.activityData && routerState.activityData.Id === activityId) {
      console.log('PortalActivityEditResolver: Using activity data from router state for ID:', activityId);
      return of(routerState.activityData);
    }
    
    console.log('PortalActivityEditResolver: No router state data, fetching from API for ID:', activityId);
    return getActivityFromAPI(activityId, this.backend);
  }
}

@Injectable()
export class PortalActivityDepartmentsResolver {
  constructor(private backend: BusinessDepartmentService, private activityService: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    const activityId = +route.params['aid'];
    const routerState = window.history.state;
    
    if (routerState && routerState.activityData && routerState.activityData.Id === activityId) {
      const businessId = routerState.activityData.BusinessId || BaseServices.BusinessId;
      return this.backend.getCachedBusinessDepartmentByBusinessId(businessId);
    }
    return getActivityFromAPI(activityId, this.activityService).pipe(
      switchMap((activity: any) => {
        const businessId = activity?.BusinessId || BaseServices.BusinessId;
        return this.backend.getCachedBusinessDepartmentByBusinessId(businessId);
      })
    );
  }
}

@Injectable()
export class PortalActivityUsersResolver {
  constructor(private backend: ActivityServices, private userService: UserService) {}
  resolve(route: ActivatedRouteSnapshot) {
    const activityId = +route.params['aid'];
    const routerState = window.history.state;
    
    if (routerState && routerState.activityData && routerState.activityData.Id === activityId) {
      const businessId = routerState.activityData.BusinessId || BaseServices.BusinessId;
      console.log('PortalActivityUsersResolver: Using router state data, getting users for businessId:', businessId, 'using /employeecontactusers endpoint');
      return this.userService.getEmployeeContactUsers(businessId);
    }
    
    return getActivityFromAPI(activityId, this.backend).pipe(
      switchMap((activity: any) => {
        const businessId = activity?.BusinessId || BaseServices.BusinessId;
        return this.userService.getEmployeeContactUsers(businessId);
      })
    );
  }
}

@Injectable()
export class PortalActivityChecklistResolver {
  constructor(private backend: CommonChecklistService, private activityService: ActivityServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    const activityId = +route.params['aid'];
    const routerState = window.history.state;
    
    if (routerState && routerState.activityData && routerState.activityData.Id === activityId) {
      const businessId = routerState.activityData.BusinessId || BaseServices.BusinessId;
      return this.backend.getCheckListforTemplate(
        0,
        BaseServices.ApplicationId,
        0,
        businessId,
        0
      );
    }
    
    return getActivityFromAPI(activityId, this.activityService).pipe(
      switchMap((activity: any) => {
        const businessId = activity?.BusinessId || BaseServices.BusinessId;
        return this.backend.getCheckListforTemplate(
          0,
          BaseServices.ApplicationId,
          0,
          businessId,
          0
        );
      })
    );
  }
}
